module.exports = __webpack_public_path__ + "static/media/dish_card11.de89b088.png";